import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { DynamicQueryParams, KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetFollowedRequest = KeyPaginationQueryParams & DynamicQueryParams;

export type GetFollowedResponse = PaginatedResource<number>;

export const getFollowed = createGetEndpoint<GetFollowedRequest, GetFollowedResponse>(
	(request) => `/api/v3/core/followers/sonar-objects?${getQueryString(request)}`
);
